import { render } from "./CrudVisitRequests.vue?vue&type=template&id=d8eb3504&scoped=true"
import script from "./CrudVisitRequests.vue?vue&type=script&lang=js"
export * from "./CrudVisitRequests.vue?vue&type=script&lang=js"

import "./CrudVisitRequests.vue?vue&type=style&index=0&id=d8eb3504&lang=css"
import "./CrudVisitRequests.vue?vue&type=style&index=1&id=d8eb3504&scoped=true&lang=postcss"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8eb3504"]])

export default __exports__